// removed by extract-text-webpack-plugin
module.exports = {"blue":"hover__blue___3VOXa bg-blue","green":"hover__green___10nWH bg-green","red":"hover__red___2H1d1 bg-red","slate":"hover__slate___2fUO4 bg-slate","white":"hover__white___2tNSA bg-white"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/ButtonDivider/style/hover.css
// module id = 111
// module chunks = 0 2